export const ssoGQLFields = () => `
  authorizationUrl
  buttonText
  clientId
  clientSecret
  idpUrl
  logoutUrl
  name
  provider
  scopes
  settingsUrl
  status
  tokenUrl
  type
  userProfileUrl
`;
//# sourceMappingURL=sso.fields.js.map